import * as React from "react";
import { IconProps } from "./IconProps";

export const IconCalendar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="calendar">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.33333 1.3335C5.70152 1.3335 6 1.63197 6 2.00016V2.66683H10V2.00016C10 1.63197 10.2985 1.3335 10.6667 1.3335C11.0349 1.3335 11.3333 1.63197 11.3333 2.00016V2.66683H13.3333C13.7015 2.66683 14 2.96531 14 3.3335V13.3335C14 13.7017 13.7015 14.0002 13.3333 14.0002H2.66667C2.29848 14.0002 2 13.7017 2 13.3335V3.3335C2 2.96531 2.29848 2.66683 2.66667 2.66683H4.66667V2.00016C4.66667 1.63197 4.96514 1.3335 5.33333 1.3335ZM3.33333 4.00016V6.00016H12.6667V4.00016H3.33333ZM12.6667 7.3335H3.33333V12.6668H12.6667V7.3335Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
